const ptBR = {
  header: {
    about: 'Sobre mim',
    projects: 'Projetos',
    contact: 'Contato',
  },
  hero: {
    greeting: 'Olá, eu sou',
    profession: 'Engenheiro de Software.',
    seeMore: 'Ver mais',
  },
  about: {
    sectionTag: 'sobre mim',
    title: 'Criando <span>experiências</span> digitais.',
    bio: `Meu nome é Leonardo — Leo pra quem tem intimidade. Comecei minha jornada no desenvolvimento de software em 2018, movido pela curiosidade e pela vontade de construir coisas que funcionam muito bem.
    <br/><br/>
    Me especializo no ecossistema JavaScript, com experiência profunda em <strong>React.js</strong>, <strong>Node.js</strong> e <strong>TypeScript</strong>. Tenho foco em arquitetura limpa, código sustentável e entrega de valor real — não apenas features.`,
    skillsTitle: 'tech stack',
    highlightYears: 'Anos de exp.',
    highlightProjects: 'Projetos',
    highlightTech: 'Tecnologias',
  },
  projects: {
    title: 'Projetos',
    comingSoon: 'Em breve',
    seeGitHub: 'Ver repositórios no GitHub',
  },
  contact: {
    title: 'Contato',
    sectionTag: 'contato',
    headline: "Vamos construir algo <span>juntos</span>.",
    subtitle: "Estou sempre aberto a novas oportunidades, colaborações ou só uma boa conversa. Escolha o canal que preferir e me chama.",
  },
}

export default ptBR
